import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Navbar.css";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [transparent, setTransparent] = useState(false);

  const location = useLocation();
  const isHome = location.pathname === "/";
  const isNuestrasRedes = location.pathname === "/nuestras-redes";
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();

  const handleHomeClick = () => {
    setMenuOpen(false);
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setTransparent(window.scrollY > 50);
    };
    if (isHome) {
      window.addEventListener("scroll", handleScroll);
    }
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);


  const navClass = isHome
    ? transparent
      ? "navbar navbar-transparent"
      : "navbar navbar-home"
    : "navbar navbar-black";

  return (
    <nav className={navClass}>
      <div className="navbar-inner-container">
        <a href="/" className="logo">
          <img src="/img/simbolo-02.png" alt="Logo SparklingTech" />
        </a>

        <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? "✖" : "☰"}
        </div>

        <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
          <li><button onClick={handleHomeClick} className="link-button">Home</button></li>
          
          <li className="dropdown">
            <Link to="/about" onClick={() => setMenuOpen(false)}>Conócenos</Link>
            <ul className="dropdown-menu">
              <li><Link to="/about" onClick={() => setMenuOpen(false)}>¿Quiénes somos?</Link></li>
              <li><Link to="/sparkling-social" onClick={() => setMenuOpen(false)}>Sparkling Social</Link></li>
            </ul>
          </li>

          <li className="dropdown">
            <Link to="/projects" onClick={() => setMenuOpen(false)}>Proyectos</Link>
            <ul className="dropdown-menu">
              <li><Link to="/projects" onClick={() => setMenuOpen(false)}>Ver todos</Link></li>
              <li><a href="https://neuroglint.sparklingtech.es/" target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)}>NeuroGlint</a></li>
              <li><a href="https://adaia.sparklingtech.es/" target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)}>ADAIA</a></li>
            </ul>
          </li>

          <li className="dropdown">
            <Link to="/movespark" onClick={() => setMenuOpen(false)}>Laboratorios</Link>
            <ul className="dropdown-menu">
              <li><Link to="/movespark" onClick={() => setMenuOpen(false)}>MoveSpark Lab</Link></li>
            </ul>
          </li>

          <li><Link to="/mas-alla-del-id" onClick={() => setMenuOpen(false)}>Más allá del I + D + i</Link></li>
          <li><Link to="/nuestras-redes" onClick={() => setMenuOpen(false)}>Nuestras Redes</Link></li>
          <li><Link to="/contacto" onClick={() => setMenuOpen(false)}>Contáctanos</Link></li>

          {/* SOLO en /nuestras-redes se muestra el botón de cerrar sesión si está loggeado */}
          {isNuestrasRedes && isAuthenticated && (
            <li>
              <button
                onClick={() => {
                  logout();
                  navigate("/nuestras-redes");
                  setMenuOpen(false);
                }}
                className="link-button"
              >
                Cerrar sesión
              </button>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
